import { DOMAIN, REPORT_DOMAIN } from "../constants/env";

export const DOMAIN_API_URI = DOMAIN;
export const REPORT_DOMAIN_API_URI = REPORT_DOMAIN;
export const PATH_API_URI = "/";

export const MONTH_LIMIT = 12;
